export const whoamiQueryKey = ['auth', 'whoami']
